import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getLearningTeams } from 'state/LearningTeams/learningTeamsSlice';
import {
  fetchProgramsForDropdown,
  fetchProjects,
  fetchFacilitators,
} from 'state/Schedule/ScheduleSlice';
export const useDataForEventCreation = () => {
  const dispatch = useDispatch();

  // Fetch data for filter side panel and filter pills
  useEffect(() => {
    dispatch(fetchFacilitators());
    dispatch(getLearningTeams());
    dispatch(fetchProjects());
    dispatch(fetchProgramsForDropdown());
  }, [dispatch]);
};

export default useDataForEventCreation;
